import React from "react";
import { MessageSquare, Search } from "lucide-react";
import Row from "@/components/InboxRow";
import { FILTERS } from "./inboxModel";
import "./Inbox.scss";

const EmptyList = ({ filter, term, onReset, onBrowse }) => {
  if (term || filter !== "all") {
    return (
      <div className="inbox-empty">
        <p className="inbox-empty__title">No conversations match</p>
        <button type="button" className="inbox-empty__link" onClick={onReset}>
          Show all conversations
        </button>
      </div>
    );
  }
  return (
    <div className="inbox-empty">
      <span className="inbox-empty__icon">
        <MessageSquare size={22} aria-hidden="true" />
      </span>
      <p className="inbox-empty__title">No conversations yet</p>
      <p className="inbox-empty__body">
        Accepted introductions and direct messages from agents show up&nbsp;here.
      </p>
      <button type="button" className="btn btn-primary inbox-empty__cta" onClick={onBrowse}>
        Browse Buyer Want&#8209;Listings
      </button>
    </div>
  );
};

const InboxList = ({ rows, selectedKey, onSelect, filter, onFilter, term, onTerm, unreadCount, loading, onBrowse }) => (
  <section className="inbox-list" aria-label="Conversations">
    <div className="inbox-list__head">
      <h1 className="inbox-list__title">Messages</h1>
      <label className="inbox-search">
        <Search size={16} aria-hidden="true" />
        <input
          type="search"
          value={term}
          onChange={(event) => onTerm(event.target.value)}
          placeholder="Search names, addresses, messages"
          aria-label="Search conversations"
        />
      </label>
      <div className="inbox-filters" role="tablist" aria-label="Filter conversations">
        {FILTERS.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={filter === item.key}
            title={item.title}
            className={`inbox-filter${filter === item.key ? " is-active" : ""}`}
            onClick={() => onFilter(item.key)}
          >
            {item.label}
            {item.key === "unread" && unreadCount ? <span className="inbox-filter__count">{unreadCount}</span> : null}
          </button>
        ))}
      </div>
    </div>
    {loading && !rows.length ? (
      <ul className="inbox-list__rows" aria-hidden="true">
        {[0, 1, 2, 3].map((n) => (
          <li key={n} className="inbox-row is-skeleton">
            <span className="inbox-avatar" />
            <span className="inbox-row__body">
              <span className="inbox-skel inbox-skel--name" />
              <span className="inbox-skel inbox-skel--line" />
            </span>
          </li>
        ))}
      </ul>
    ) : rows.length ? (
      <ul className="inbox-list__rows">
        {rows.map((row) => (
          <Row key={row.key} row={row} selected={row.key === selectedKey} onSelect={onSelect} />
        ))}
      </ul>
    ) : (
      <EmptyList
        filter={filter}
        term={term}
        onReset={() => {
          onFilter("all");
          onTerm("");
        }}
        onBrowse={onBrowse}
      />
    )}
  </section>
);

export const ThreadPlaceholder = () => (
  <div className="inbox-thread-empty">
    <span className="inbox-empty__icon">
      <MessageSquare size={22} aria-hidden="true" />
    </span>
    <p className="inbox-empty__title">Pick a conversation</p>
    <p className="inbox-empty__body">Introductions and direct messages open&nbsp;here.</p>
  </div>
);

export default InboxList;
